import { SUPPORTED_EXCHANGES } from "../../constants/supported-cex";
import { QUEST_TYPE, QUEST_REWARD_TYPE, QUEST_SOCIAL, QUEST_FREQUENCY, SPINNING_WHEEL_TYPE } from "./quest.enums";
import { z } from "zod";

const TwitterCampaignInteraction = z.object({
  campaignName: z.string().min(1).optional().nullable(),
  XAccountUsernameToFollow: z.string().optional().nullable(),
  XAccountIdToFollow: z.string().optional().nullable(),
  partnerName: z.string().optional().nullable(),
});

export const QuestRequirementsSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal(QUEST_TYPE.SOCIAL_CONNECTION),
    connectSocial: z.nativeEnum(QUEST_SOCIAL),
  }),
  z.object({
    type: z.literal(QUEST_TYPE.TRADING_VOLUME),
    tradeVolume: z.number().positive(),
    cexs: z.array(z.nativeEnum(SUPPORTED_EXCHANGES)),
  }),
  z.object({
    type: z.literal(QUEST_TYPE.CEX_CONNECTION),
    connectCex: z.nativeEnum(SUPPORTED_EXCHANGES),
  }),
  z.object({
    type: z.literal(QUEST_TYPE.TMA_TON_CONNECTION),
  }),
  z.object({
    type: z.literal(QUEST_TYPE.TMA_FIRST_CEX_CONNECTION),
  }),
  z.object({
    type: z.literal(QUEST_TYPE.SPINNING_WHEEL),
    spinningWheelType: z.nativeEnum(SPINNING_WHEEL_TYPE),
    spinningWheelSlots: z.array(
      z.object({
        probability: z.number().nonnegative(),
        rewardCount: z.number().nonnegative(),
        rewardType: z.nativeEnum(QUEST_REWARD_TYPE),
      }),
    ),
  }),
  z.object({
    type: z.literal(QUEST_TYPE.USER_AFFILIATED),
    connectCex: z.nativeEnum(SUPPORTED_EXCHANGES),
  }),
  z.object({
    type: z.literal(QUEST_TYPE.TWITTER_LIKE_POST),
    postId: z.string().min(1),
  }),
  z.object({
    type: z.literal(QUEST_TYPE.TWITTER_RETWEET_POST),
    postId: z.string().min(1),
  }),
  z.object({
    type: z.literal(QUEST_TYPE.TWITTER_FOLLOW_ACCOUNT),
    accountId: z.string().min(1),
  }),
  z
    .object({
      type: z.literal(QUEST_TYPE.TWITTER_COMMENT_POST),
      XPostIdToComment: z.string().min(1),
    })
    .merge(TwitterCampaignInteraction),
  z
    .object({
      type: z.literal(QUEST_TYPE.TWITTER_SEND_POST),
    })
    .merge(TwitterCampaignInteraction),
]);
export type QuestRequirements = z.infer<typeof QuestRequirementsSchema>;

export const QuestSchema = z.object({
  id: z.number(),
  type: z.nativeEnum(QUEST_TYPE),
  frequency: z.nativeEnum(QUEST_FREQUENCY),
  name: z.string().min(1),
  description: z.string().min(1),
  rewardCount: z.number().positive().default(1),
  rewardType: z.nativeEnum(QUEST_REWARD_TYPE),
  requirements: QuestRequirementsSchema,
  isActive: z.boolean().default(false),
  startDate: z.coerce.date(),
  endDate: z.coerce.date().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type Quest = z.infer<typeof QuestSchema>;
